module.exports = __webpack_public_path__ + "static/media/welcome-1.ca6c191f.jpg";